<template>
  <v-col cols="12" class="pb-0">
    <header class="ml-0">
      <p class="txtHeader2 ml-0">Firmas e poderes</p>
    </header>
    <v-row>
      <v-col cols="4" class="pl-0">
        <RadioSelect :options="$aux.ResponsabilidadePreenchedor" required v-model="model.responsabilidade" label="Responsabilidade"/>
      </v-col>
      <v-col cols="4" v-if="!clearTipoAssinatura" class="pl-0">
        <input-select v-model="model.tipoAssinatura" label="Tipo de assinatura"
          :options="$aux.TipoAssinaturaSocioCorrentistaPJ" required />
      </v-col>
    </v-row>
  </v-col>
</template>
<script>
export default {
  props: {
    value: null,
    clearTipoAssinatura: {
      type: Boolean,
      default: false,
    }
  },
  date () {
    return {
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    }
  },
  methods: {
    setValue (value) {
      this.$set(this, 'model', value)
    }
  },

}
</script>
<style scoped>
  .txtHeader2{
    font-weight: 600;
    font-size: 16px;
  }
</style>
